export default __webpack_public_path__ + "static/media/open-account.0ba618d8.svg";